import { devConfig } from "./devConfig"
import { prodConfig } from "./prodConfig"

const isProduction = true

export const config = isProduction ? prodConfig : devConfig
